import * as React from 'react'

import Kicker from '../../00-Primitives/Kicker'
import HeadlineThree from '../../00-Primitives/Headlines/HeadlineThree'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Paragraph from 'content-components/_Primatives/Paragraph'
import TextBlock from '../../00-Primitives/TextBlock'
import Ruler from '../../00-Primitives/Ruler'

import style from './style.scss'

export type Props = {
  bodyText: string
  headlineText: string
  kickerText?: string
  miniKickerText?: string
  rulerClass?: string
  small?: boolean
}

function CTABase(props: Props) {
  const {
    bodyText = '',
    headlineText,
    kickerText = '',
    miniKickerText,
    rulerClass,
    small,
  } = props

  return (
    <>
      {!kickerText && <Ruler className={rulerClass} />}
      {kickerText && <Kicker>{kickerText}</Kicker>}
      {!small ? (
        <HeadlineTwo className={style.headline}>{headlineText}</HeadlineTwo>
      ) : (
        <HeadlineThree className={style.headline}>{headlineText}</HeadlineThree>
      )}
      {bodyText.startsWith('<p>') || bodyText.startsWith('<ul>') ? (
        <TextBlock className={style.bodyText}>{bodyText}</TextBlock>
      ) : (
        <Paragraph className={style.bodyText} small={small}>
          {bodyText}
        </Paragraph>
      )}
      {miniKickerText && (
        <div className={style.miniKickerText}>{miniKickerText}</div>
      )}
    </>
  )
}

export default CTABase
